import { map, merge, isNil, filter, isEmpty, is, takeLast, find, omit } from "ramda";

const isInvalid = (value, name) => isNil(value) || isEmpty(value) || value[name] === "";

const getMediaValue = (value) => {
  if (isNil(value.id)) {
    return null;
  }

  const result = {};
  if (is(File, value.id)) {
    result.id = value.id;
  } else {
    result.id = value.id.id;
  }
  result.rotation = value.rotation;
  if (!isNil(value.crop)) {
    result.crop = {
      x: value.crop.x,
      y: value.crop.y,
      width: value.crop.width,
      height: value.crop.height,
    };
  } else if (!isNil(value.croppedId)) {
    result.cropId = value.croppedId.id;
  }

  return result;
};

const getValueForHtml = (value, campo) => {
  if (value.length === 0) {
    return value[0][campo];
  }
  return map((obj) => obj[campo], value);
};

const generateControlId = () => {
  const randomNumber = window.crypto.getRandomValues(new Uint32Array(1));
  return takeLast(5, randomNumber[0].toString(36));
};

const getControlIdValue = (value) => {
  if (isNil(value)) {
    return generateControlId();
  }
  return value;
};

const handlerValuesFromMedias = (values) => map((value) => getMediaValue(value), values);

const handlerMultimedia = (defaultConfig, value) => {
  const result = handlerValuesFromMedias(value);
  const resultWithValues = find((val) => !isNil(val), result);
  if (isEmpty(result) || isNil(resultWithValues)) {
    return null;
  }
  return merge(defaultConfig, {
    value: null,
    mediaInfo: handlerValuesFromMedias(value),
    inputType: "MEDIA",
  });
};

const getObjectForField = (obj, value) => {
  if (isNil(value) && obj.type === "SELECT") {
    return null;
  }

  if (isNil(value)) {
    return "";
  }

  const defaultConfig = {
    path: obj.path,
    translatable: obj.translatable,
    contentFields: null,
    value: map((varObj) => varObj.value, value),
    mediaInfo: null,
    inputType: "TEXT",
    cssList: null,
    controlId: map((varObj) => getControlIdValue(varObj.controlId), value),
  };

  switch (obj.type) {
    case "HTML":
      return merge(defaultConfig, {
        inputType: "HTML",
        value: getValueForHtml(value, "value"),
        cssList: getValueForHtml(value, "cssList"),
      });
    case "MULTIMEDIA":
      return handlerMultimedia(defaultConfig, value);
    case "SELECT":
      return merge(omit(["value", "cssList", "cssRawList", "mediaInfo", "contentFields"], defaultConfig), {
        selectedOptions: defaultConfig.value,
        inputType: "SELECT",
      });
    case "MAP":
      return merge(omit(["value", "cssList", "cssRawList", "mediaInfo", "contentFields"], defaultConfig), {
        inputType: "MAP",
        map: filter((v) => !isNil(v), defaultConfig.value),
      });
    case "RATING":
      return merge(defaultConfig, { inputType: "RATING" });
    default:
      return defaultConfig;
  }
};

const getValueForNode = (node, value) => {
  if (isNil(value) && node.type === "SELECT") {
    return null;
  }
  if (node.repeatable === true) {
    return map(
      (obj) => obj[node.path],
      filter((val) => !isInvalid(val, node.path), value)
    );
  }
  return [value];
};

const valueToContentFieldVisitor = (node, value) => getObjectForField(node, getValueForNode(node, value[node.path]));

export default valueToContentFieldVisitor;
